// collection of shorthand utilities

export const objectKeys = <Obj extends {}>(obj: Obj): (keyof Obj)[] =>
  Object.keys(obj) as (keyof Obj)[];

export const objectValues = <Obj extends {}>(obj: Obj): Obj[keyof Obj][] =>
  Object.values(obj);

export const objectEntries = <Obj extends {}>(
  obj: Obj,
): [keyof Obj, Obj[keyof Obj]][] =>
  Object.entries(obj) as [keyof Obj, Obj[keyof Obj]][];

export const objectFromEntries = <TKey extends string, TValue>(
  entries: Iterable<[TKey, TValue]>,
): { [key: string]: TValue } => Object.fromEntries(entries);
